declare global {
  interface Window {
    // Kept on window so separately bundled copies of this package share one load.
    __recaptchaScriptLoad?: Promise<void>;
  }
}

export const injectGoogleReCaptchaScript = async (recaptchaId: string): Promise<void> => {
  if (window?.grecaptcha) {
    return;
  }

  if (!recaptchaId) {
    return Promise.reject("reCAPTCHA ID is required");
  }

  if (window.__recaptchaScriptLoad) {
    return window.__recaptchaScriptLoad;
  }

  window.__recaptchaScriptLoad = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    const url = `https://www.google.com/recaptcha/api.js?render=${recaptchaId}&badge=bottomleft`;

    script.src = url;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load recaptcha script"));

    document.head.appendChild(script);
  }).catch((error: unknown) => {
    window.__recaptchaScriptLoad = undefined;
    throw error;
  });

  return window.__recaptchaScriptLoad;
};
